module.exports = __webpack_public_path__ + "logout.ee790beb2b529618e6fffe88c38d51f3.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/menu/selected/logout.svg
// module id = 1148
// module chunks = 0